import '../css/app.css'
import '../css/fonts.css'
import './bootstrap'

import { createInertiaApp, Head, Link } from '@inertiajs/vue3'
import * as Sentry from '@sentry/vue'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createApp, h } from 'vue'
import { ZiggyVue } from 'ziggy-js'

createInertiaApp({
    title: (title) => (title ? `${title}` + ' | Kam Zajít Olomouc' : 'Kam Zajít Olomouc'),
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .component('Head', Head)
            .component('Link', Link)

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN,
            tracesSampleRate: 1.0,
            environment: import.meta.env.VITE_APP_ENV,
        })

        return app.mount(el)
    },
    progress: {
        color: '#FF1100',
    },
})
